// import React, { useState, useEffect } from 'react';

// const Contactus = () => {
//   const [submitted, setSubmitted] = useState(false);
//   const [meetingSubmitted, setMeetingSubmitted] = useState(false);
//   const [showMeetingForm, setShowMeetingForm] = useState(false);
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [isSubmittingContact, setIsSubmittingContact] = useState(false);
//   const [isSubmittingMeeting, setIsSubmittingMeeting] = useState(false);
  
//   const [formData, setFormData] = useState({
//     name: '', contact: '', email: '', country: '', message: ''
//   });
  
//   const [meetingData, setMeetingData] = useState({
//     name: '', contact: '', date: ''
//   });

//   const slides = [
//     { image: '/10.jpg', title: 'Experience Wild Africa', subtitle: 'Connect with nature like never before' },
//     { image: '/22.jpg', title: 'Ngorongoro National Park', subtitle: 'Reach new heights OF TANZANIA with Our CEO' },
//     { image: '/12.jpg', title: 'Serengeti Adventures', subtitle: 'Witness the great migration' },
//     { image: '/20.jpg', title: 'Cultural Immersion', subtitle: 'Discover authentic Tanzania' },
//     { image: '/4.jpg', title: 'Safari Magic', subtitle: 'Create memories that last forever' }
//   ];

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentSlide((prev) => (prev + 1) % slides.length);
//     }, 5000);
//     return () => clearInterval(timer);
//   }, [slides.length]);

//   const countries = [
//     'United States', 'United Kingdom', 'Canada', 'Australia', 'Germany', 'France', 
//     'Italy', 'Spain', 'Netherlands', 'Switzerland', 'Sweden', 'Norway', 'Denmark',
//     'Kenya', 'Uganda', 'Rwanda', 'South Africa', 'Botswana', 'Zambia', 'Zimbabwe'
//   ];

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: name === 'email' ? value.toLowerCase() : value }));
//   };

//   const handleMeetingInputChange = (e) => {
//     const { name, value } = e.target;
//     setMeetingData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmittingContact(true);
//     // Simulate API call
//     setTimeout(() => {
//       setSubmitted(true);
//       setIsSubmittingContact(false);
//       setFormData({ name: '', contact: '', email: '', country: '', message: '' });
//       setTimeout(() => setSubmitted(false), 5000);
//     }, 1000);
//   };

//   const handleMeetingSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmittingMeeting(true);
//     // Simulate API call
//     setTimeout(() => {
//       setMeetingSubmitted(true);
//       setIsSubmittingMeeting(false);
//       setMeetingData({ name: '', contact: '', date: '' });
//       setShowMeetingForm(false);
//       setTimeout(() => setMeetingSubmitted(false), 5000);
//     }, 1000);
//   };

//   const toggleMeetingForm = () => setShowMeetingForm(!showMeetingForm);
//   const goToSlide = (index) => setCurrentSlide(index);

//   return (
//     <div className="min-h-screen bg-white" style={{ fontFamily: "'Lora', serif" }}>
//       {/* HERO SLIDESHOW */}
//       <section className="relative text-white overflow-hidden h-[60vh] flex items-center justify-center">
//         <div className="absolute inset-0">
//           {slides.map((slide, i) => (
//             <div
//               key={i}
//               className={`absolute inset-0 transition-opacity duration-1000 ${i === currentSlide ? 'opacity-100' : 'opacity-0'}`}
//               style={{ backgroundImage: `url(${slide.image})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
//             />
//           ))}
//         </div>

//         <div className="relative z-10 max-w-6xl mx-auto px-4 text-center">
//           <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ color: 'white' }}>
//             CONTACT US
//           </h1>
//           <div className="text-lg md:text-xl mb-6 max-w-2xl mx-auto">
//             <span className="block" style={{ color: '#228b22' }}>{slides[currentSlide]?.title}</span>
//             <span className="block text-base md:text-lg mt-2 opacity-90" style={{ color: '#9acd32' }}>
//               {slides[currentSlide]?.subtitle}
//             </span>
//           </div>

//           <div className="flex flex-col sm:flex-row gap-4 justify-center">
//             <a href="#contact-form" className="inline-flex items-center gap-3 text-white px-6 py-3 rounded-full font-medium transition-all hover:scale-105"
//                style={{ backgroundColor: '#228b22' }}>
//               <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 7.89a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
//               </svg>
//               SEND MESSAGE
//             </a>
//             <a href="https://wa.me/255753182737" target="_blank" rel="noopener noreferrer"
//                className="inline-flex items-center gap-3 bg-transparent border-2 border-white text-white px-6 py-3 rounded-full font-medium transition-all hover:scale-105 hover:bg-white hover:text-[#228b22]">
//               <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                 <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.525 3.687"/>
//               </svg>
//               WHATSAPP
//             </a>
//           </div>
//         </div>

//         <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex space-x-2 z-20">
//           {slides.map((_, i) => (
//             <button key={i} onClick={() => goToSlide(i)}
//               className={`w-2 h-2 rounded-full transition-all ${i === currentSlide ? 'bg-white scale-110' : 'bg-white bg-opacity-50'}`}
//               aria-label={`Slide ${i + 1}`}
//             />
//           ))}
//         </div>

//         <div className="absolute bottom-6 right-6 animate-bounce">
//           <svg className="w-6 h-6 text-white opacity-70" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"/>
//           </svg>
//         </div>
//       </section>

//       {/* HOW TO REACH US */}
//       <section className="py-16 bg-white">
//         <div className="max-w-6xl mx-auto px-6 md:px-0">
//           <h2 className="text-4xl font-medium tracking-[0.05em] mb-6 text-center uppercase" style={{ color: '#2f4f2f' }}>
//             HOW TO REACH US
//           </h2>
//           <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-8 text-center max-w-2xl mx-auto">
//             We're available through multiple channels to ensure you get the support you need for your Tanzania adventure.
//           </p>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             {[
//               { icon: 'phone', title: 'PHONE', desc: 'Direct voice communication for urgent inquiries', link: 'tel:+255753182737', text: '+255 753 182 737' },
//               { icon: 'email', title: 'EMAIL', desc: 'Detailed inquiries and formal communication', link: 'mailto:safaris@tanzania-yetutravellers.com', text: 'safaris@tanzania-yetutravellers.com' },
//               { icon: 'location', title: 'ADDRESS', desc: 'Visit our office for in-person consultation', link: null, text: 'Moshi, Kilimanjaro. Tanzania' }
//             ].map((item, i) => (
//               <div key={i} className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all hover:scale-105 text-center">
//                 <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: '#228b22' }}>
//                   <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     {item.icon === 'phone' && <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>}
//                     {item.icon === 'email' && <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 7.89a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>}
//                     {item.icon === 'location' && <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/></>}
//                   </svg>
//                 </div>
//                 <h3 className="text-xl font-medium mb-2" style={{ color: '#2f4f2f' }}>{item.title}</h3>
//                 <p className="text-gray-600 mb-4 text-base">{item.desc}</p>
//                 {item.link ? (
//                   <a href={item.link} className="text-[#228b22] font-medium hover:underline break-all" style={{ textTransform: item.title === 'EMAIL' ? 'lowercase' : 'none' }}>
//                     {item.text}
//                   </a>
//                 ) : (
//                   <p className="text-[#228b22] font-medium">{item.text}</p>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* CONTACT FORM & INFO */}
//       <section id="contact-form" className="py-16 bg-white">
//         <div className="max-w-6xl mx-auto px-6 md:px-0 grid grid-cols-1 lg:grid-cols-2 gap-12">
//           {/* LEFT: CONNECT WITH US */}
//           <div className="space-y-8">
//             <div>
//               <h2 className="text-3xl font-bold mb-6" style={{ color: '#2f4f2f' }}>CONNECT WITH US</h2>
//               <p className="text-base md:text-lg text-gray-700 leading-relaxed">
//                 We're here to help you plan your dream safari. Reach out through WhatsApp, follow us on social media, or visit our office in Moshi, Kilimanjaro, Tanzania for personalized consultation.
//               </p>
//             </div>

//             <div className="bg-white p-8 rounded-2xl shadow-lg">
//               <h3 className="text-xl font-medium mb-6" style={{ color: '#2f4f2f' }}>FOLLOW OUR SAFARI ADVENTURES</h3>
//               <div className="space-y-4 mb-6">
//                 {[
//                   { icon: 'twitter', link: 'https://x.com/Africana2011', handle: '@Africana2011', desc: 'Follow for daily safari updates' },
//                   { icon: 'pinterest', link: 'https://www.pinterest.com/africanadventur/', handle: 'African Adventure Travellers', desc: 'Watch our safari videos' },
//                   { icon: 'facebook', link: 'https://www.facebook.com/africanadventures', handle: 'African Adventure Travellers', desc: 'Join our community' }
//                 ].map((s, i) => (
//                   <div key={i} className="flex items-center gap-4">
//                     <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#228b22' }}>
//                       <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
//                         {s.icon === 'twitter' && <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>}
//                         {s.icon === 'pinterest' && <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.174-.105-.949-.199-2.403.042-3.441.219-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.653 2.567-.992 3.992-.282 1.195.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.357-.631-2.744-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24.009 12.017 24.009c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641 .001 12.017 .001"/>}
//                         {s.icon === 'facebook' && <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>}
//                       </svg>
//                     </div>
//                     <div>
//                       <a href={s.link} target="_blank" rel="noopener noreferrer" className="text-[#228b22] font-medium hover:underline">
//                         {s.handle}
//                       </a>
//                       <p className="text-sm text-gray-600">{s.desc}</p>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//               <a href="https://wa.me/255753182737" target="_blank" rel="noopener noreferrer"
//                  className="inline-flex items-center gap-3 text-white px-6 py-3 rounded-full font-medium transition-all hover:scale-105"
//                  style={{ backgroundColor: '#228b22' }}>
//                 <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                   <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.525 3.687"/>
//                 </svg>
//                 CHAT ON WHATSAPP
//               </a>
//             </div>

//             <div className="bg-white p-8 rounded-2xl shadow-lg">
//               <h3 className="text-xl font-medium mb-6" style={{ color: '#2f4f2f' }}>WHY CHOOSE TANZANIA YETU?</h3>
//               <div className="space-y-4">
//                 {[
//                   { title: 'Expert Local Knowledge', desc: 'Born and raised guides with intimate knowledge of Tanzania\'s wildlife and culture' },
//                   { title: '24/7 Support', desc: 'Round-the-clock assistance before, during, and after your safari' },
//                   { title: 'Customized Itineraries', desc: 'Tailored experiences that match your interests, budget, and timeline' }
//                 ].map((item, i) => (
//                   <div key={i} className="flex items-start gap-4">
//                     <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#9acd32' }}>
//                       <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
//                       </svg>
//                     </div>
//                     <div>
//                       <h4 className="font-medium text-gray-800 mb-1">{item.title}</h4>
//                       <p className="text-gray-600 text-sm">{item.desc}</p>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>

//           {/* RIGHT: CONTACT FORM */}
// <div className="relative rounded-2xl overflow-hidden shadow-xl" style={{ backgroundImage: 'url(/51.jpg)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
//   {/* ---- REMOVE THE WHITE OVERLAY ---- */}
//   <div className="p-8 h-full">
//     <h2 className="text-2xl font-bold mb-6 text-white">SEND US A MESSAGE</h2>
//     <form onSubmit={handleSubmit} className="space-y-4">
//       {['name', 'contact', 'email', 'country', 'message'].map((field, i) => (
//         <div key={i}>
//           <label className="block text-sm font-medium mb-1 text-white">
//             {field.toUpperCase()} {field !== 'message' && '*'}
//           </label>
//           {field === 'message' ? (
//             <textarea
//               name={field} placeholder="Write your message here..." value={formData[field]} onChange={handleInputChange}
//               required rows="5" className="w-full p-3 rounded border focus:outline-none focus:ring-2"
//               style={{ borderColor: '#9acd32', backgroundColor: 'rgba(255,255,255,0.85)' }}
//             />
//           ) : field === 'country' ? (
//             <select
//               name={field} value={formData[field]} onChange={handleInputChange} required
//               className="w-full p-3 rounded border focus:outline-none focus:ring-2"
//               style={{ borderColor: '#9acd32', backgroundColor: 'rgba(255,255,255,0.85)' }}
//             >
//               <option value="">-- Select your country --</option>
//               {countries.map(c => <option key={c} value={c}>{c}</option>)}
//             </select>
//           ) : (
//             <input
//               type={field === 'email' ? 'email' : field === 'contact' ? 'tel' : 'text'}
//               name={field} placeholder={`Your ${field === 'contact' ? 'Contact' : field.charAt(0).toUpperCase() + field.slice(1)}`}
//               value={formData[field]} onChange={handleInputChange} required
//               className={`w-full p-3 rounded border focus:outline-none focus:ring-2 ${field === 'email' ? 'lowercase' : ''}`}
//               style={{ borderColor: '#9acd32', backgroundColor: 'rgba(255,255,255,0.85)' }}
//             />
//           )}
//         </div>
//       ))}
//       <button type="submit" disabled={isSubmittingContact}
//         className="w-full text-white px-6 py-3 rounded font-medium transition-all hover:scale-105"
//         style={{ backgroundColor: '#228b22', opacity: isSubmittingContact ? 0.7 : 1 }}>
//         {isSubmittingContact ? 'SENDING...' : 'SEND MESSAGE'}
//       </button>
//     </form>
//     {submitted && (
//       <div className="mt-4 p-3 rounded text-center text-white" style={{ backgroundColor: '#228b22' }}>
//         Thank you! We'll get back to you soon.
//       </div>
//     )}
//   </div>
// </div>
//         </div>
//       </section>

//       {/* MEET OUR CEO — REDESIGNED */}
//       <section className="py-20 bg-white">
//         <div className="max-w-7xl mx-auto px-6">
//           {/* Section Header */}
//           <div className="text-center mb-12">
//             <h2 className="text-3xl font-bold tracking-wide" style={{ color: '#2f4f2f' }}>
//               MEET OUR CEO
//             </h2>
//           </div>

//           {/* Main Content Grid */}
//           <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            
//             {/* LEFT: CEO Image + Info Card */}
//             <div className="lg:col-span-4">
//               <div className="bg-white rounded-2xl shadow-lg overflow-hidden sticky top-8">
//                 {/* Profile Image */}
//                 <div className="relative">
//                   <div className="aspect-square overflow-hidden">
//                     <img
//                       src="https://www.uganda-safaris-tours.com/ug/img/team/robert1.jpg"
//                       alt="CEO Mugabe Robert"
//                       className="w-full h-full object-cover"
//                     />
//                   </div>
//                 </div>

//                 {/* Info Cards */}
//                 <div className="p-6 space-y-3">
//                   <div className="text-center mb-4">
//                     <h3 className="text-xl font-bold mb-1" style={{ color: '#228b22' }}>Mugabe Robert</h3>
//                     <p className="text-gray-600 text-sm">Founder & CEO</p>
//                   </div>

//                   <div className="flex items-center gap-3 text-gray-700">
//                     <div className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#228b22' }}>
//                       <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
//                       </svg>
//                     </div>
//                     <div>
//                       <p className="text-sm font-medium" style={{ color: '#2f4f2f' }}>Tourism Expert</p>
//                       <p className="text-xs text-gray-600">Senior Safari Guide</p>
//                     </div>
//                   </div>

//                   <div className="flex items-center gap-3 text-gray-700">
//                     <div className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#228b22' }}>
//                       <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
//                       </svg>
//                     </div>
//                     <div>
//                       <p className="text-sm font-medium" style={{ color: '#2f4f2f' }}>Cultural Ambassador</p>
//                       <p className="text-xs text-gray-600">East Africa Specialist</p>
//                     </div>
//                   </div>

//                   <div className="flex items-center gap-3 text-gray-700">
//                     <div className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#228b22' }}>
//                       <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"/>
//                       </svg>
//                     </div>
//                     <div>
//                       <p className="text-sm font-medium" style={{ color: '#2f4f2f' }}>Languages</p>
//                       <p className="text-xs text-gray-600">English, Swahili</p>
//                     </div>
//                   </div>

//                   <div className="pt-4 border-t border-gray-200">
//                     <button 
//                       onClick={toggleMeetingForm}
//                       className="w-full inline-flex items-center justify-center gap-2 text-white px-5 py-2.5 rounded-full font-medium transition-all hover:scale-105"
//                       style={{ backgroundColor: '#228b22' }}>
//                       <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
//                       </svg>
//                       SCHEDULE A MEETING
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* RIGHT: Biography + Meeting Form */}
//             <div className="lg:col-span-8 space-y-8">
              
//               {/* Biography Section */}
//               <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8">
//                 <div className="flex items-center gap-3 mb-5">
//                   <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: '#9acd32' }}>
//                     <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
//                     </svg>
//                   </div>
//                   <h3 className="text-xl font-bold" style={{ color: '#2f4f2f' }}>ABOUT ROBERT</h3>
//                 </div>

//                 <div className="space-y-4 text-gray-700 leading-relaxed text-base">
//                   <p>
//                     <span className="font-semibold" style={{ color: '#228b22' }}>Mugabe Robert</span> is a Senior Travel Consultant and Safari Guide with African Adventure Travellers Ltd, a licensed Ugandan tour company and proud member of the Association of Uganda Tour Operators (AUTO). Born in Mengo, Buganda Kingdom, Robert began guiding at just 14 years old and has since become one of our most dedicated and knowledgeable guides.
//                   </p>
                  
//                   <p>
//                     He received his tourism education in England and completed advanced safari training in South Africa, equipping him with international expertise and professional skills. With years of field experience, he has led countless safaris across Uganda and East Africa — including wildlife tours, gorilla trekking, birding, and cultural adventures.
//                   </p>
                  
//                   <p>
//                     Robert is known for his professionalism, calm personality, and deep understanding of East Africa's wildlife and culture, ensuring every traveller enjoys a safe and memorable experience.
//                   </p>

//                   {/* Language Proficiency */}
//                   <div className="pt-4 border-t border-gray-200">
//                     <h4 className="font-semibold mb-2 flex items-center gap-2" style={{ color: '#2f4f2f' }}>
//                       <svg className="w-5 h-5" style={{ color: '#228b22' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"/>
//                       </svg>
//                       Language Proficiency
//                     </h4>
//                     <p className="text-gray-700">
//                       Robert is fluent in <span className="font-medium text-gray-900">English</span>, speaks conversational <span className="font-medium text-gray-900">Swahili</span>, and has knowledge of local languages across East Africa, allowing him to communicate effectively with both local communities and international travellers.
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               {/* Meeting Request Form */}
//               {showMeetingForm && (
//                 <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 animate-slide-down">
//                   <div className="flex items-center justify-between mb-5">
//                     <div className="flex items-center gap-3">
//                       <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: '#228b22' }}>
//                         <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
//                         </svg>
//                       </div>
//                       <h3 className="text-xl font-bold" style={{ color: '#2f4f2f' }}>SCHEDULE YOUR CONSULTATION</h3>
//                     </div>
//                     <button 
//                       onClick={toggleMeetingForm}
//                       className="text-gray-400 hover:text-gray-600 transition-colors">
//                       <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"/>
//                       </svg>
//                     </button>
//                   </div>

//                   <p className="text-gray-700 mb-5 text-base leading-relaxed">
//                     Ready to plan your dream safari? Schedule a personal meeting with Robert to bring your adventure to life with expert insights and personalized recommendations.
//                   </p>

//                   <form onSubmit={handleMeetingSubmit} className="space-y-4">
//                     <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                       <div>
//                         <label className="block text-sm font-semibold mb-2" style={{ color: '#2f4f2f' }}>
//                           YOUR NAME *
//                         </label>
//                         <input 
//                           type="text" 
//                           name="name" 
//                           placeholder="Enter your full name" 
//                           value={meetingData.name} 
//                           onChange={handleMeetingInputChange} 
//                           required
//                           className="w-full p-3 rounded-xl border-2 focus:outline-none focus:ring-2 transition-all"
//                           style={{ borderColor: '#e5e7eb', focusRingColor: '#228b22' }}
//                         />
//                       </div>
//                       <div>
//                         <label className="block text-sm font-semibold mb-2" style={{ color: '#2f4f2f' }}>
//                           CONTACT NUMBER *
//                         </label>
//                         <input 
//                           type="tel" 
//                           name="contact" 
//                           placeholder="Your phone number" 
//                           value={meetingData.contact} 
//                           onChange={handleMeetingInputChange} 
//                           required
//                           className="w-full p-3 rounded-xl border-2 focus:outline-none focus:ring-2 transition-all"
//                           style={{ borderColor: '#e5e7eb' }}
//                         />
//                       </div>
//                     </div>
                    
//                     <div>
//                       <label className="block text-sm font-semibold mb-2" style={{ color: '#2f4f2f' }}>
//                         PREFERRED DATE *
//                       </label>
//                       <input 
//                         type="date" 
//                         name="date" 
//                         value={meetingData.date} 
//                         onChange={handleMeetingInputChange} 
//                         required
//                         className="w-full p-3 rounded-xl border-2 focus:outline-none focus:ring-2 transition-all"
//                         style={{ borderColor: '#e5e7eb' }}
//                       />
//                     </div>

//                     <button 
//                       type="submit" 
//                       disabled={isSubmittingMeeting}
//                       className="w-full text-white px-6 py-3 rounded-xl font-semibold transition-all hover:scale-105 flex items-center justify-center gap-2"
//                       style={{ backgroundColor: '#228b22', opacity: isSubmittingMeeting ? 0.7 : 1 }}>
//                       {isSubmittingMeeting ? (
//                         <>
//                           <svg className="animate-spin w-5 h-5" fill="none" viewBox="0 0 24 24">
//                             <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                             <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                           </svg>
//                           SCHEDULING...
//                         </>
//                       ) : (
//                         <>
//                           <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
//                           </svg>
//                           CONFIRM MEETING REQUEST
//                         </>
//                       )}
//                     </button>
//                   </form>

//                   {meetingSubmitted && (
//                     <div className="mt-4 p-3 rounded-xl text-center text-white animate-fade-in" style={{ backgroundColor: '#228b22' }}>
//                       <div className="flex items-center justify-center gap-2">
//                         <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
//                         </svg>
//                         <span className="font-semibold">Meeting request sent! We'll confirm your appointment soon.</span>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               )}

//               {/* Why Meet Robert Section */}
//               <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8">
//                 <h3 className="text-xl font-bold mb-5" style={{ color: '#2f4f2f' }}>WHY MEET WITH ROBERT?</h3>
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//                   {[
//                     { 
//                       icon: 'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z',
//                       title: 'Personalized Safari Planning',
//                       desc: 'Get tailored itineraries based on your interests, budget, and travel style'
//                     },
//                     { 
//                       icon: 'M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z',
//                       title: 'Local Expertise',
//                       desc: 'Benefit from decades of on-ground experience and insider knowledge'
//                     },
//                     { 
//                       icon: 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
//                       title: 'Best Value Guarantee',
//                       desc: 'Direct consultation ensures competitive pricing and maximum value'
//                     },
//                     { 
//                       icon: 'M13 10V3L4 14h7v7l9-11h-7z',
//                       title: 'Quick Response Time',
//                       desc: 'Get immediate answers and fast-track your safari planning process'
//                     }
//                   ].map((item, i) => (
//                     <div key={i} className="flex items-start gap-3 p-4 rounded-xl transition-all hover:shadow-md" style={{ backgroundColor: '#f9fafb' }}>
//                       <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#9acd32' }}>
//                         <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={item.icon}/>
//                         </svg>
//                       </div>
//                       <div>
//                         <h4 className="font-semibold mb-1 text-gray-900 text-sm">{item.title}</h4>
//                         <p className="text-sm text-gray-600">{item.desc}</p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//             </div>
//           </div>
//         </div>
//       </section>

//       <style jsx>{`
//         @keyframes fade-in-up { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
//         @keyframes slide-up { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
//         @keyframes slide-down { from { opacity: 0; transform: translateY(-20px); } to { opacity: 1; transform: translateY(0); } }
//         @keyframes fade-in { from { opacity: 0; } to { opacity: 1; } }
//         .animate-fade-in-up { animation: fade-in-up 1s ease-out; }
//         .animate-slide-up { animation: slide-up 0.8s ease-out both; }
//         .animate-slide-down { animation: slide-down 0.5s ease-out both; }
//         .animate-fade-in { animation: fade-in 0.5s ease-out both; }
//       `}</style>
//     </div>
//   );
// };

// export default Contactus;



import React, { useState, useEffect } from 'react';

const Contactus = () => {
  const [submitted, setSubmitted] = useState(false);
  const [meetingSubmitted, setMeetingSubmitted] = useState(false);
  const [showMeetingForm, setShowMeetingForm] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isSubmittingContact, setIsSubmittingContact] = useState(false);
  const [isSubmittingMeeting, setIsSubmittingMeeting] = useState(false);
  
  const [formData, setFormData] = useState({
    name: '', contact: '', email: '', country: '', message: ''
  });
  
  const [meetingData, setMeetingData] = useState({
    name: '', contact: '', date: ''
  });

  const slides = [
    { image: '/10.jpg', title: 'Experience Wild Africa', subtitle: 'Connect with nature like never before' },
    { image: '/22.jpg', title: 'Ngorongoro National Park', subtitle: 'Reach new heights OF TANZANIA with Our CEO' },
    { image: '/12.jpg', title: 'Serengeti Adventures', subtitle: 'Witness the great migration' },
    { image: '/20.jpg', title: 'Cultural Immersion', subtitle: 'Discover authentic Tanzania' },
    { image: '/4.jpg', title: 'Safari Magic', subtitle: 'Create memories that last forever' }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const countries = [
    'United States', 'United Kingdom', 'Canada', 'Australia', 'Germany', 'France', 
    'Italy', 'Spain', 'Netherlands', 'Switzerland', 'Sweden', 'Norway', 'Denmark',
    'Kenya', 'Uganda', 'Rwanda', 'South Africa', 'Botswana', 'Zambia', 'Zimbabwe'
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: name === 'email' ? value.toLowerCase() : value }));
  };

  const handleMeetingInputChange = (e) => {
    const { name, value } = e.target;
    setMeetingData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmittingContact(true);
    setTimeout(() => {
      setSubmitted(true);
      setIsSubmittingContact(false);
      setFormData({ name: '', contact: '', email: '', country: '', message: '' });
      setTimeout(() => setSubmitted(false), 5000);
    }, 1000);
  };

  const handleMeetingSubmit = async (e) => {
    e.preventDefault();
    setIsSubmittingMeeting(true);
    setTimeout(() => {
      setMeetingSubmitted(true);
      setIsSubmittingMeeting(false);
      setMeetingData({ name: '', contact: '', date: '' });
      setShowMeetingForm(false);
      setTimeout(() => setMeetingSubmitted(false), 5000);
    }, 1000);
  };

  const toggleMeetingForm = () => setShowMeetingForm(!showMeetingForm);
  const goToSlide = (index) => setCurrentSlide(index);

  return (
    <div className="min-h-screen bg-white">
      {/* HERO SLIDESHOW */}
      <section className="relative text-white overflow-hidden h-[60vh] flex items-center justify-center">
        <div className="absolute inset-0">
          {slides.map((slide, i) => (
            <div
              key={i}
              className={`absolute inset-0 transition-opacity duration-1000 ${i === currentSlide ? 'opacity-100' : 'opacity-0'}`}
              style={{ backgroundImage: `url(${slide.image})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
            />
          ))}
        </div>

        <div className="relative z-10 max-w-6xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ color: 'white', fontFamily: "'Lora', serif" }}>
            CONTACT US
          </h1>
          <div className="text-lg md:text-xl mb-6 max-w-2xl mx-auto">
            <span className="block" style={{ color: '#228b22', fontFamily: "'Lora', serif" }}>{slides[currentSlide]?.title}</span>
            <span className="block text-base md:text-lg mt-2 opacity-90" style={{ color: '#9acd32', fontFamily: "'Lora', serif" }}>
              {slides[currentSlide]?.subtitle}
            </span>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="#contact-form" className="inline-flex items-center gap-3 text-white px-6 py-3 rounded-full font-medium transition-all hover:scale-105"
               style={{ backgroundColor: '#228b22' }}>
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 7.89a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
              </svg>
              SEND MESSAGE
            </a>
            <a href="https://wa.me/255753182737" target="_blank" rel="noopener noreferrer"
               className="inline-flex items-center gap-3 bg-transparent border-2 border-white text-white px-6 py-3 rounded-full font-medium transition-all hover:scale-105 hover:bg-white hover:text-[#228b22]">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.525 3.687"/>
              </svg>
              WHATSAPP
            </a>
          </div>
        </div>

        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex space-x-2 z-20">
          {slides.map((_, i) => (
            <button key={i} onClick={() => goToSlide(i)}
              className={`w-2 h-2 rounded-full transition-all ${i === currentSlide ? 'bg-white scale-110' : 'bg-white bg-opacity-50'}`}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>

        <div className="absolute bottom-6 right-6 animate-bounce">
          <svg className="w-6 h-6 text-white opacity-70" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"/>
          </svg>
        </div>
      </section>

      {/* HOW TO REACH US */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6 md:px-0">
          <h2 className="text-4xl font-medium tracking-[0.05em] mb-6 text-center uppercase" style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}>
            HOW TO REACH US
          </h2>
          <p className="text-base md:text-lg text-gray-700 leading-relaxed mb-8 text-center max-w-2xl mx-auto" style={{ fontFamily: "'Times New Roman', Times, serif", lineHeight: '1.7' }}>
            We're available through multiple channels to ensure you get the support you need for your Tanzania adventure.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { icon: 'phone', title: 'PHONE', desc: 'Direct voice communication for urgent inquiries', link: 'tel:+255753182737', text: '+255 753 182 737' },
              { icon: 'email', title: 'EMAIL', desc: 'Detailed inquiries and formal communication', link: 'mailto:safaris@tanzania-yetutravellers.com', text: 'safaris@tanzania-yetutravellers.com' },
              { icon: 'location', title: 'ADDRESS', desc: 'Visit our office for in-person consultation', link: null, text: 'Moshi, Kilimanjaro. Tanzania' }
            ].map((item, i) => (
              <div key={i} className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all hover:scale-105 text-center">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{ backgroundColor: '#228b22' }}>
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    {item.icon === 'phone' && <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>}
                    {item.icon === 'email' && <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 7.89a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>}
                    {item.icon === 'location' && <><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/></>}
                  </svg>
                </div>
                <h3 className="text-xl font-medium mb-2" style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}>{item.title}</h3>
                <p className="text-gray-600 mb-4 text-base" style={{ fontFamily: "'Times New Roman', Times, serif", lineHeight: '1.7' }}>{item.desc}</p>
                {item.link ? (
                  <a href={item.link} className="text-[#228b22] font-medium hover:underline break-all" style={{ textTransform: item.title === 'EMAIL' ? 'lowercase' : 'none', fontFamily: "'Times New Roman', Times, serif" }}>
                    {item.text}
                  </a>
                ) : (
                  <p className="text-[#228b22] font-medium" style={{ fontFamily: "'Times New Roman', Times, serif" }}>{item.text}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CONTACT FORM & INFO */}
      <section id="contact-form" className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6 md:px-0 grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* LEFT: CONNECT WITH US */}
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}>CONNECT WITH US</h2>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed" style={{ fontFamily: "'Times New Roman', Times, serif", lineHeight: '1.7' }}>
                We're here to help you plan your dream safari. Reach out through WhatsApp, follow us on social media, or visit our office in Moshi, Kilimanjaro, Tanzania for personalized consultation.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <h3 className="text-xl font-medium mb-6" style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}>FOLLOW OUR SAFARI ADVENTURES</h3>
              <div className="space-y-4 mb-6">
                {[
                  { icon: 'twitter', link: 'https://x.com/Africana2011', handle: '@Africana2011', desc: 'Follow for daily safari updates' },
                  { icon: 'pinterest', link: 'https://www.pinterest.com/africanadventur/', handle: 'African Adventure Travellers', desc: 'Watch our safari videos' },
                  { icon: 'facebook', link: 'https://www.facebook.com/africanadventures', handle: 'African Adventure Travellers', desc: 'Join our community' }
                ].map((s, i) => (
                  <div key={i} className="flex items-center gap-4">
                    <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#228b22' }}>
                      <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 24 24">
                        {s.icon === 'twitter' && <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>}
                        {s.icon === 'pinterest' && <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.174-.105-.949-.199-2.403.042-3.441.219-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.653 2.567-.992 3.992-.282 1.195.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.357-.631-2.744-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24.009 12.017 24.009c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641 .001 12.017 .001"/>}
                        {s.icon === 'facebook' && <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>}
                      </svg>
                    </div>
                    <div>
                      <a href={s.link} target="_blank" rel="noopener noreferrer" className="text-[#228b22] font-medium hover:underline" style={{ fontFamily: "'Times New Roman', Times, serif" }}>
                        {s.handle}
                      </a>
                      <p className="text-sm text-gray-600" style={{ fontFamily: "'Times New Roman', Times, serif" }}>{s.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
              <a href="https://wa.me/255753182737" target="_blank" rel="noopener noreferrer"
                 className="inline-flex items-center gap-3 text-white px-6 py-3 rounded-full font-medium transition-all hover:scale-105"
                 style={{ backgroundColor: '#228b22' }}>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.525 3.687"/>
                </svg>
                CHAT ON WHATSAPP
              </a>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-lg">
              <h3 className="text-xl font-medium mb-6" style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}>WHY CHOOSE TANZANIA YETU?</h3>
              <div className="space-y-4">
                {[
                  { title: 'Expert Local Knowledge', desc: 'Born and raised guides with intimate knowledge of Tanzania\'s wildlife and culture' },
                  { title: '24/7 Support', desc: 'Round-the-clock assistance before, during, and after your safari' },
                  { title: 'Customized Itineraries', desc: 'Tailored experiences that match your interests, budget, and timeline' }
                ].map((item, i) => (
                  <div key={i} className="flex items-start gap-4">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#9acd32' }}>
                      <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
                      </svg>
                    </div>
                    <div>
                      <h4 className="font-medium text-gray-800 mb-1" style={{ fontFamily: "'Lora', serif" }}>{item.title}</h4>
                      <p className="text-gray-600 text-sm" style={{ fontFamily: "'Times New Roman', Times, serif", lineHeight: '1.7' }}>{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* RIGHT: CONTACT FORM */}
          <div className="relative rounded-2xl overflow-hidden shadow-xl" style={{ backgroundImage: 'url(/51.jpg)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <div className="p-8 h-full">
              <h2 className="text-2xl font-bold mb-6 text-white" style={{ fontFamily: "'Lora', serif" }}>SEND US A MESSAGE</h2>
              <form onSubmit={handleSubmit} className="space-y-4">
                {['name', 'contact', 'email', 'country', 'message'].map((field, i) => (
                  <div key={i}>
                    <label className="block text-sm font-medium mb-1 text-white" style={{ fontFamily: "'Times New Roman', Times, serif" }}>
                      {field.toUpperCase()} {field !== 'message' && '*'}
                    </label>
                    {field === 'message' ? (
                      <textarea
                        name={field} placeholder="Write your message here..." value={formData[field]} onChange={handleInputChange}
                        required rows="5" className="w-full p-3 rounded border focus:outline-none focus:ring-2"
                        style={{ borderColor: '#9acd32', backgroundColor: 'rgba(255,255,255,0.85)', fontFamily: "'Times New Roman', Times, serif" }}
                      />
                    ) : field === 'country' ? (
                      <select
                        name={field} value={formData[field]} onChange={handleInputChange} required
                        className="w-full p-3 rounded border focus:outline-none focus:ring-2"
                        style={{ borderColor: '#9acd32', backgroundColor: 'rgba(255,255,255,0.85)', fontFamily: "'Times New Roman', Times, serif" }}
                      >
                        <option value="">-- Select your country --</option>
                        {countries.map(c => <option key={c} value={c}>{c}</option>)}
                      </select>
                    ) : (
                      <input
                        type={field === 'email' ? 'email' : field === 'contact' ? 'tel' : 'text'}
                        name={field} placeholder={`Your ${field === 'contact' ? 'Contact' : field.charAt(0).toUpperCase() + field.slice(1)}`}
                        value={formData[field]} onChange={handleInputChange} required
                        className={`w-full p-3 rounded border focus:outline-none focus:ring-2 ${field === 'email' ? 'lowercase' : ''}`}
                        style={{ borderColor: '#9acd32', backgroundColor: 'rgba(255,255,255,0.85)', fontFamily: "'Times New Roman', Times, serif" }}
                      />
                    )}
                  </div>
                ))}
                <button type="submit" disabled={isSubmittingContact}
                  className="w-full text-white px-6 py-3 rounded font-medium transition-all hover:scale-105"
                  style={{ backgroundColor: '#228b22', opacity: isSubmittingContact ? 0.7 : 1, fontFamily: "'Lora', serif" }}>
                  {isSubmittingContact ? 'SENDING...' : 'SEND MESSAGE'}
                </button>
              </form>
              {submitted && (
                <div className="mt-4 p-3 rounded text-center text-white" style={{ backgroundColor: '#228b22', fontFamily: "'Times New Roman', Times, serif" }}>
                  Thank you! We'll get back to you soon.
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* MEET OUR CEO */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold tracking-wide" style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}>
              MEET OUR CEO
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            <div className="lg:col-span-4">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden sticky top-8">
                <div className="aspect-square overflow-hidden">
                  <img
                    src="https://www.uganda-safaris-tours.com/ug/img/team/robert1.jpg"
                    alt="CEO Mugabe Robert"
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="p-6 space-y-3">
                  <div className="text-center mb-4">
                    <h3 className="text-xl font-bold mb-1" style={{ color: '#228b22', fontFamily: "'Lora', serif" }}>Mugabe Robert</h3>
                    <p className="text-gray-600 text-sm" style={{ fontFamily: "'Times New Roman', Times, serif" }}>Founder & CEO</p>
                  </div>

                  {/* Info Cards */}
                  {[
                    { icon: 'briefcase', label: 'Tourism Expert', sub: 'Senior Safari Guide' },
                    { icon: 'globe', label: 'Cultural Ambassador', sub: 'East Africa Specialist' },
                    { icon: 'message', label: 'Languages', sub: 'English, Swahili' }
                  ].map((info, i) => (
                    <div key={i} className="flex items-center gap-3 text-gray-700">
                      <div className="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#228b22' }}>
                        <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          {info.icon === 'briefcase' && <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>}
                          {info.icon === 'globe' && <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>}
                          {info.icon === 'message' && <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"/>}
                        </svg>
                      </div>
                      <div>
                        <p className="text-sm font-medium" style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}>{info.label}</p>
                        <p className="text-xs text-gray-600" style={{ fontFamily: "'Times New Roman', Times, serif" }}>{info.sub}</p>
                      </div>
                    </div>
                  ))}

                  <div className="pt-4 border-t border-gray-200">
                    <button 
                      onClick={toggleMeetingForm}
                      className="w-full inline-flex items-center justify-center gap-2 text-white px-5 py-2.5 rounded-full font-medium transition-all hover:scale-105"
                      style={{ backgroundColor: '#228b22', fontFamily: "'Lora', serif" }}>
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                      </svg>
                      SCHEDULE A MEETING
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT: BIO + FORM */}
            <div className="lg:col-span-8 space-y-8">
              <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: '#9acd32' }}>
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold" style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}>ABOUT ROBERT</h3>
                </div>

                <div className="space-y-4 text-gray-700 leading-relaxed text-base" style={{ fontFamily: "'Times New Roman', Times, serif", lineHeight: '1.7' }}>
                  <p>
                    <span className="font-semibold" style={{ color: '#228b22' }}>Mugabe Robert</span> is a Senior Travel Consultant and Safari Guide with African Adventure Travellers Ltd, a licensed Ugandan tour company and proud member of the Association of Uganda Tour Operators (AUTO). Born in Mengo, Buganda Kingdom, Robert began guiding at just 14 years old and has since become one of our most dedicated and knowledgeable guides.
                  </p>
                  <p>
                    He received his tourism education in England and completed advanced safari training in South Africa, equipping him with international expertise and professional skills. With years of field experience, he has led countless safaris across Uganda and East Africa — including wildlife tours, gorilla trekking, birding, and cultural adventures.
                  </p>
                  <p>
                    Robert is known for his professionalism, calm personality, and deep understanding of East Africa's wildlife and culture, ensuring every traveller enjoys a safe and memorable experience.
                  </p>

                  <div className="pt-4 border-t border-gray-200">
                    <h4 className="font-semibold mb-2 flex items-center gap-2" style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}>
                      <svg className="w-5 h-5" style={{ color: '#228b22' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"/>
                      </svg>
                      Language Proficiency
                    </h4>
                    <p>
                      Robert is fluent in <span className="font-medium text-gray-900">English</span>, speaks conversational <span className="font-medium text-gray-900">Swahili</span>, and has knowledge of local languages across East Africa, allowing him to communicate effectively with both local communities and international travellers.
                    </p>
                  </div>
                </div>
              </div>

              {/* Meeting Form */}
              {showMeetingForm && (
                <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 animate-slide-down">
                  <div className="flex items-center justify-between mb-5">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ backgroundColor: '#228b22' }}>
                        <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                        </svg>
                      </div>
                      <h3 className="text-xl font-bold" style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}>SCHEDULE YOUR CONSULTATION</h3>
                    </div>
                    <button onClick={toggleMeetingForm} className="text-gray-400 hover:text-gray-600">
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"/>
                      </svg>
                    </button>
                  </div>

                  <p className="text-gray-700 mb-5 text-base leading-relaxed" style={{ fontFamily: "'Times New Roman', Times, serif", lineHeight: '1.7' }}>
                    Ready to plan your dream safari? Schedule a personal meeting with Robert to bring your adventure to life with expert insights and personalized recommendations.
                  </p>

                  <form onSubmit={handleMeetingSubmit} className="space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-semibold mb-2" style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}>YOUR NAME *</label>
                        <input type="text" name="name" placeholder="Enter your full name" value={meetingData.name} onChange={handleMeetingInputChange} required
                          className="w-full p-3 rounded-xl border-2 focus:outline-none focus:ring-2 transition-all"
                          style={{ borderColor: '#e5e7eb', fontFamily: "'Times New Roman', Times, serif" }} />
                      </div>
                      <div>
                        <label className="block text-sm font-semibold mb-2" style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}>CONTACT NUMBER *</label>
                        <input type="tel" name="contact" placeholder="Your phone number" value={meetingData.contact} onChange={handleMeetingInputChange} required
                          className="w-full p-3 rounded-xl border-2 focus:outline-none focus:ring-2 transition-all"
                          style={{ borderColor: '#e5e7eb', fontFamily: "'Times New Roman', Times, serif" }} />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-semibold mb-2" style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}>PREFERRED DATE *</label>
                      <input type="date" name="date" value={meetingData.date} onChange={handleMeetingInputChange} required
                        className="w-full p-3 rounded-xl border-2 focus:outline-none focus:ring-2 transition-all"
                        style={{ borderColor: '#e5e7eb', fontFamily: "'Times New Roman', Times, serif" }} />
                    </div>
                    <button type="submit" disabled={isSubmittingMeeting}
                      className="w-full text-white px-6 py-3 rounded-xl font-semibold transition-all hover:scale-105 flex items-center justify-center gap-2"
                      style={{ backgroundColor: '#228b22', opacity: isSubmittingMeeting ? 0.7 : 1, fontFamily: "'Lora', serif" }}>
                      {isSubmittingMeeting ? (
                        <>Scheduling...</>
                      ) : (
                        <>Confirm Meeting Request</>
                      )}
                    </button>
                  </form>

                  {meetingSubmitted && (
                    <div className="mt-4 p-3 rounded-xl text-center text-white" style={{ backgroundColor: '#228b22', fontFamily: "'Times New Roman', Times, serif" }}>
                      Meeting request sent! We'll confirm your appointment soon.
                    </div>
                  )}
                </div>
              )}

              {/* Why Meet Robert */}
              <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8">
                <h3 className="text-xl font-bold mb-5" style={{ color: '#2f4f2f', fontFamily: "'Lora', serif" }}>WHY MEET WITH ROBERT?</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                  {[
                    { title: 'Personalized Safari Planning', desc: 'Get tailored itineraries based on your interests, budget, and travel style' },
                    { title: 'Local Expertise', desc: 'Benefit from decades of on-ground experience and insider knowledge' },
                    { title: 'Best Value Guarantee', desc: 'Direct consultation ensures competitive pricing and maximum value' },
                    { title: 'Quick Response Time', desc: 'Get immediate answers and fast-track your safari planning process' }
                  ].map((item, i) => (
                    <div key={i} className="flex items-start gap-3 p-4 rounded-xl transition-all hover:shadow-md" style={{ backgroundColor: '#f9fafb' }}>
                      <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#9acd32' }}>
                        <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
                        </svg>
                      </div>
                      <div>
                        <h4 className="font-semibold mb-1 text-gray-900 text-sm" style={{ fontFamily: "'Lora', serif" }}>{item.title}</h4>
                        <p className="text-sm text-gray-600" style={{ fontFamily: "'Times New Roman', Times, serif" }}>{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        @keyframes slide-down { from { opacity: 0; transform: translateY(-20px); } to { opacity: 1; transform: translateY(0); } }
        .animate-slide-down { animation: slide-down 0.5s ease-out both; }
      `}</style>
    </div>
  );
};

export default Contactus;